import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutPayee401kFundList extends Layout {
    layoutheaderTitle: LayoutHeader;
    sourcePayee401kFund: DataSource;
    tablePayee401kFund: Table;
}
